import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { conditionalRender } from '@repo/toolkit/conditional-render'
import InnerBox from '@repo/ui/inner-box'
import Loader from '@repo/ui/loader'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'
import { useFormContext } from 'react-hook-form'

import { getHowDidYouObtainLecBrochures } from '../../../../api/how-did-you-obtain-lec-brochures/get-how-did-you-obtain-lec-brochures'
import { howDidYouObtainLECBrochureFields } from '../../../../lib/types/fields/how-did-you-obtain-lec-brochures/how-did-you-obtain-lec-brochures'
import { EnrollmentChildInput } from '../../../../lib/types/models/enrollment/enrollment-child-input'
import { FormControl, FormField, FormItem } from '../../../elements/forms/form'
import ControlledInput from '../../../elements/inputs/controlled-input'
import ControlledRadioInput from '../../../elements/inputs/controlled-radio-input'
import ControlledSelectInput from '../../../elements/inputs/controlled-select-input'

const ClientEnrollmentOtherInformation = () => {
  const form = useFormContext<EnrollmentChildInput>()

  const { data: howDidYouObtainLecBrochures } = useQuery({
    queryKey: ['how-did-you-obtain-lec-brochures', howDidYouObtainLECBrochureFields],
    queryFn: () => getHowDidYouObtainLecBrochures(howDidYouObtainLECBrochureFields)
  })

  if (!howDidYouObtainLecBrochures) return <Loader center />

  return (
    <InnerBox className="rounded-lg p-4 flex flex-col gap-4 ">
      <Typography variant="text" color={tailwindColors.grey.DEFAULT}>
        Autres informations
      </Typography>

      <div className="flex items-center gap-5 mobile:flex-col mobile:gap-4 mobile:items-start">
        <div className="flex items-center gap-1 mobile:flex-col mobile:gap-0 mobile:items-start">
          <Typography variant="label-semibold" color={tailwindColors.grey.DEFAULT}>
            Avez-vous en main la
          </Typography>
          <Typography.Link
            variant="label-semibold"
            color={tailwindColors.secondaryRed.DEFAULT}
            className="underline"
            onClick={() =>
              window.open('https://sejour-linguistique-lec.fr/pdf/LEC-2026.pdf', '_blank')
            }
          >
            brochure LEC Séjours Linguistiques ?*
          </Typography.Link>
        </div>
        <div className="flex items-center gap-3">
          <FormField
            control={form.control}
            name={'holdingLECBrochure'}
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <ControlledRadioInput
                    {...field}
                    label={'Oui'}
                    checked={field.value === true}
                    onCheck={() =>
                      form.setValue('holdingLECBrochure', true, { shouldValidate: true })
                    }
                  />
                </FormControl>
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name={'holdingLECBrochure'}
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <ControlledRadioInput
                    {...field}
                    label={'Non'}
                    checked={field.value === false}
                    onCheck={() =>
                      form.setValue('holdingLECBrochure', false, { shouldValidate: true })
                    }
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>
      </div>
      {form.watch('holdingLECBrochure') && (
        <FormField
          control={form.control}
          name="howDidYouObtainLECBrochureId"
          render={({ field }) => (
            <FormItem className={'flex-1'}>
              <FormControl>
                <ControlledSelectInput
                  {...field}
                  dropDownPosition="under"
                  label={"Comment l'avez-vous obtenue ?*"}
                  options={howDidYouObtainLecBrochures?.data.map((data) => ({
                    label: data.name,
                    value: data.id
                  }))}
                  selectedOption={conditionalRender(!!field.value, {
                    label:
                      howDidYouObtainLecBrochures?.data.find((data) => data.id === field.value)
                        ?.name ?? '',
                    value: field.value
                  })}
                />
              </FormControl>
            </FormItem>
          )}
        />
      )}

      <div className="flex flex-col gap-2">
        <Typography variant="label-semibold" color={tailwindColors.grey.DEFAULT}>
          Est-ce le premier séjour linguistique de votre enfant (pour une durée de plus de 7 <br />
          jours) ?*
        </Typography>

        <div className="flex items-center gap-3">
          <FormField
            control={form.control}
            name={'isChildFirstLanguageStay'}
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <ControlledRadioInput
                    {...field}
                    label={'Oui'}
                    checked={field.value === true}
                    onCheck={() =>
                      form.setValue('isChildFirstLanguageStay', true, { shouldValidate: true })
                    }
                  />
                </FormControl>
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name={'isChildFirstLanguageStay'}
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <ControlledRadioInput
                    {...field}
                    label={'Non'}
                    checked={field.value === false}
                    onCheck={() =>
                      form.setValue('isChildFirstLanguageStay', false, { shouldValidate: true })
                    }
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>
      </div>
      {form.watch('isChildFirstLanguageStay') === false && (
        <FormField
          control={form.control}
          name="childPreviousTravelOrganization"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <ControlledInput
                  {...field}
                  type="textarea"
                  placeholder="Avec quel organisme votre enfant est-il parti ?"
                />
              </FormControl>
            </FormItem>
          )}
        />
      )}
    </InnerBox>
  )
}

export default ClientEnrollmentOtherInformation
